import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { reluxQuery } from '@/api/queries'
import { createDraft } from '@/features/relux/drafts'
import { newDraft } from '@/features/relux/types'

/** Starts an amendment draft for the project behind this Relux (Rev B, C...). */
export const Route = createFileRoute('/_app/reluxes/$reluxId/amend')({ component: Amend })

function Amend() {
  const { reluxId } = Route.useParams()
  const { me } = Route.useRouteContext()
  const navigate = useNavigate()
  const { data, error } = useQuery(reluxQuery(reluxId))
  const started = useRef(false)

  useEffect(() => {
    if (!data || started.current) return
    started.current = true
    const d = newDraft({ type: 'amendment' })
    d.projectId = data.project.id
    d.projectName = data.project.name
    d.spaces = []
    void createDraft(me.real_user_id, d).then((id) =>
      navigate({
        to: '/reluxes/draft/$draftId',
        params: { draftId: id },
        search: { step: 'changes' },
        replace: true,
      }),
    )
  }, [data, me.real_user_id, navigate])

  if (error) return <p className="p-6 font-semibold text-danger">{error.message}</p>
  return <p className="p-6 text-center text-fg-muted">Starting an amendment...</p>
}
